import { Component, computed, inject } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { Illustration, IllustrationComponent, PageComponent, TertiaryButtonComponent } from '@ftr/foundation'
import { APP_MODE, AppPaths } from '@ftr/routing-paths'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'

@Component({
  selector: 'ftr-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  imports: [RouterModule, IllustrationComponent, PageComponent, TertiaryButtonComponent],
})
export class NotFoundComponent {
  readonly illustration = Illustration
  readonly appMode = inject(APP_MODE)
  private readonly router = inject(Router)
  private readonly store = inject(Store)

  protected isCourtsApp = computed(() => this.appMode() === 'courts')

  homeHref(): string {
    if (!this.isCourtsApp()) {
      return '/'
    }
    const courtSystemId = this.store.selectSnapshot(UserState.currentCourtSystem)?.id
    return courtSystemId ? `/${AppPaths.CourtSystem}/${courtSystemId}` : `/${AppPaths.CourtSystem}`
  }

  goToHome(): void {
    void this.router.navigateByUrl(this.homeHref())
  }
}
